import smoothScroll from 'smoothscroll-polyfill';
import Vue from 'vue';
import Promise from 'bluebird';
import 'normalize.css/normalize.css';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';

import './assets/styles.styl';
import App from './App';
import router from './router';

window.Promise = Promise;

smoothScroll.polyfill();

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js